import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MarkovStartvector } from "server/models"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_MARKOV_MODEL,
    StoreType,

    LoadAllMarkovStartvectors,
    DeleteMarkovStartvector,

    setMarkovStartvectors,
    setMarkovStartvectorSelected,
    setMarkovStartvectorReloadList,
    addModal,
} from "client/store"
import {
    Collapse,
    Container,
    Loader,
    PageForm,
    FormGroup,
    Label,
    SelectDropdown,
    SelectDropdownItem,
    Button,
    SpinnerIcon,
    Empty,

    PopupMenu,
    PopupMenuItem,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
} from "client/components"

import EditStartvector from "client/pages/markov/startvector/edit"
import StartvectorStateList from "client/pages/markov/startvectorState/list"

const actionButtonStyle: React.CSSProperties = {
    marginLeft: "15px",
    transform: "translateY(18px)",
}

const List = () => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const startvectors = useSelector((state: StoreType) => state.markovStartvector.startvectors)
    const startvectorSelected = useSelector((state: StoreType) => state.markovStartvector.startvectorSelected)
    const reloadList = useSelector((state: StoreType) => state.markovStartvector.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)
    const [deleteStartvector, setDeleteStartvector] = useState<MarkovStartvector>(null)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const [showPopup, setShowPopup] = useState(false)
    const [popupTarget, setPopupTarget] = useState<HTMLElement>(null)

    const hideMenu = () => {
        setShowPopup(false)
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllMarkovStartvectors(model && model.id).then((res) => {
            const prevSelected = startvectorSelected && res.find((row) => row.id === startvectorSelected.id)
            dispatch(setMarkovStartvectors(res))
            dispatch(setMarkovStartvectorSelected(prevSelected || (res.length ? res[0] : null)))
            setLoadState(IDLE)
        })
    }, [model, reloadList])

    const closeConfirm = () => {
        setDeleteStartvector(null)
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        DeleteMarkovStartvector(deleteStartvector.id, model.id).then(() => {
            dispatch(setMarkovStartvectorReloadList(false))
            setTimeout(() => {
                dispatch(setMarkovStartvectorReloadList(true))
            }, 0)

            setDeleteStartvector(null)
            setDeleteState(IDLE)
        })
    }

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    return (
        <Collapse
            show={show}
            onCollapse={() => setShow(!show)}
            title={lang.startvectors}
        >
            <Container>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <PageForm row noPaddingBottom>
                    <FormGroup>
                        <Label>{lang.startvectors}</Label>
                        <SelectDropdown title={startvectorSelected ? startvectorSelected.name : <Empty />}>
                            {
                                startvectors.map((startvector) => (
                                    <SelectDropdownItem
                                        key={startvector.id}
                                        onClick={() => dispatch(setMarkovStartvectorSelected(startvector))}
                                    >
                                        {startvector.name}
                                    </SelectDropdownItem>
                                ))
                            }
                        </SelectDropdown>
                    </FormGroup>
                    {
                        editModelAccess && (
                            <Button
                                after
                                style={actionButtonStyle}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setShowPopup(true)
                                    setPopupTarget(e.target as HTMLElement)
                                }}
                            >
                                {lang.actions}
                            </Button>
                        )
                    }
                </PageForm>
                <StartvectorStateList />

                <PopupMenu
                    show={showPopup}
                    target={popupTarget}
                    placement="bottom-end"
                    showArrow={false}
                >
                    <PopupMenuItem
                        onClick={() => dispatch(addModal({
                            key: "addStartvector",
                            content: <EditStartvector startvectorId={0} />,
                        }))}
                    >
                        {lang.add}
                    </PopupMenuItem>
                    {
                        startvectorSelected && (
                            <PopupMenuItem
                                onClick={() => dispatch(addModal({
                                    key: "editStartvector",
                                    content: <EditStartvector startvectorId={startvectorSelected.id} />,
                                }))}
                            >
                                {lang.edit}
                            </PopupMenuItem>
                        )
                    }
                    {
                        startvectorSelected && (
                            <PopupMenuItem key="copy">
                                TODO: copy
                            </PopupMenuItem>
                        )
                    }
                    {
                        startvectorSelected && (
                            <PopupMenuItem onClick={() => setDeleteStartvector(startvectorSelected)}>
                                {lang.delete}
                            </PopupMenuItem>
                        )
                    }
                </PopupMenu>

                <ConfirmWrapper
                    show={!!deleteStartvector}
                    onClose={closeConfirm}
                >
                    <Confirm>
                        <ConfirmTitle>
                            {deleteStartvector && deleteStartvector.name}
                        </ConfirmTitle>
                        <ConfirmDescription>{lang.confirmDeleteStartvector}</ConfirmDescription>

                        <ConfirmBottom>
                            <Button row onClick={closeConfirm}>{lang.cancel}</Button>
                            <Button variant="success" row onClick={onConfirmDelete}>
                                {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                            </Button>
                        </ConfirmBottom>
                    </Confirm>
                </ConfirmWrapper>
            </Container>
        </Collapse>
    )
}
export default List
